<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/5illustrations#illustrations">LIST OF ILLUSTRATIONS</a></p>
<p class="toc1"><a href="#/6start#preface">PREFACE</a></p>
<p class="toc1"><a href="#/7introduction#introduction">INTRODUCTION</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/9chap1#chap1">1. “THEIR MANNERS ARE DECOROUS AND PRAISEWORTHY”</a></p>
<p class="toc1"><a href="#/10chap2#chap2">2. THE LONG WALK OF THE NAVAHOS</a></p>
<p class="toc1"><a href="#/11chap3#chap3">3. LITTLE CROW’S WAR</a></p>
<p class="toc1"><a href="#/12page67#chap4">4. WAR COMES TO THE CHEYENNES</a></p>
<p class="toc1"><a href="#/13chap5#chap5">5. POWDER RIVER INVASION</a></p>
<p class="toc1"><a href="#/14page121#chap6">6. RED CLOUD’S WAR</a></p>
<p class="toc1"><a href="#/15chap7#chap7">7. “THE ONLY GOOD INDIAN IS A DEAD INDIAN”</a></p>
<p class="toc1"><a href="#/16chap8#chap8">8. THE RISE AND FALL OF DONEHOGAWA</a></p>
<p class="toc1"><a href="#/17chap9#chap9">9. COCHISE AND THE APACHE GUERRILLAS</a></p>
<p class="toc1"><a href="#/18page219#chap10">10. THE ORDEAL OF CAPTAIN JACK</a></p>
<p class="toc1"><a href="#/19chap11#chap11">11. THE WAR TO SAVE THE BUFFALO</a></p>
<p class="toc1"><a href="#/20page273#chap12">12. THE WAR FOR THE BLACK HILLS</a></p>
<p class="toc1"><a href="#/21page315#chap13">13. THE FLIGHT OF THE NEZ PERCÉS</a></p>
<p class="toc1"><a href="#/22chap14#chap14">14. CHEYENNE EXODUS</a></p>
<p class="toc1"><a href="#/23page351#chap15">15. STANDING BEAR BECOMES A PERSON</a></p>
<p class="toc1"><a href="#/24chap16#chap16">16. “THE UTES MUST GO!”</a></p>
<p class="toc1"><a href="#/25page391#chap17">17. THE LAST OF THE APACHE CHIEFS</a></p>
<p class="toc1"><a href="#/26page415#chap18">18. DANCE OF THE GHOSTS</a></p>
<p class="toc1"><a href="#/27chap19#chap19">19. WOUNDED KNEE</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/28biography#biography">A BIOGRAPHY OF DEE BROWN</a></p>
<p class="toc1"><a href="#/41page451#chap20">NOTES</a></p>
<p class="toc1"><a href="#/42chap21#chap21">BIBLIOGRAPHY</a></p>
<p class="toc1"><a href="#/43chap22#chap22">INDEX</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-TOC.vue?7be84d15